import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  Calendar,
  MapPin,
  Users,
  Award,
  ArrowRight,
  Filter,
  Search,
  Building2,
  Heart,
  GraduationCap,
  Settings,
  FileText,
  Target,
  Star
} from 'lucide-react';
import Partners from '../Partners';
import { useNavigate } from 'react-router-dom';

// Add custom CSS for animations
const customStyles = `
  @keyframes spin-slow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes spin-slow-reverse {
    from { transform: rotate(360deg); }
    to { transform: rotate(0deg); }
  }
  .animate-spin-slow {
    animation: spin-slow 20s linear infinite;
  }
  .animate-spin-slow-reverse {
    animation: spin-slow-reverse 25s linear infinite;
  }
`;

// Inject custom styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = customStyles;
  document.head.appendChild(styleSheet);
}

const Projects = () => {
  const navigate = useNavigate()
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const projectsData = [
    {
      id: 1,
      title: 'Healthy Village BCC Materials Development',
      category: 'Health',
      location: 'Bihar',
      client: 'Transforming Rural India Foundation',
      details: 'Supported Transforming Rural India Foundation for developing BCC materials on "Health Village" for Panchayati Raj Department, Bihar',
      impact: 'Enhanced health awareness in rural communities',
      icon: Heart
    },
    {
      id: 2,
      title: 'Institutional Strengthening Initiative',
      category: 'Capacity Building',
      location: 'Pune, Ranchi',
      client: 'Animal Rescue Trust, Paroksha Foundation',
      details: 'Institutional strengthening of Animal Rescue Trust, Pune; Paroksha Foundation, Ranchi and other organizations',
      impact: 'Improved organizational capacity and effectiveness',
      icon: Building2
    },
    {
      id: 3,
      title: 'EdTech Model Testing & Customer Acquisition',
      category: 'Education',
      location: 'Multiple Locations',
      client: 'Quizeal, Escuela Connect, Vitta Edu',
      details: 'Supported Quizeal, Escuela Connect and Vitta Edu edtech in testing of model in the field and customer acquisition',
      impact: 'Successful market validation and user acquisition',
      icon: GraduationCap
    },
    {
      id: 4,
      title: 'Training Module Development Project',
      category: 'Education',
      location: 'Multiple Locations',
      client: 'Mamta/Welspun Foundation',
      details: 'Supported Mamta/Welspun Foundation in development of training module, flipbook and mood meter and TOT',
      impact: 'Enhanced training effectiveness and engagement',
      icon: FileText
    },
    {
      id: 5,
      title: 'COVID-19 Impact Assessment',
      category: 'Research',
      location: 'Bihar',
      client: 'Heifer International',
      details: 'Impact of Covid-19 on small landholders and landless farmers in Bihar for Heifer International',
      impact: 'Informed policy decisions and support programs',
      icon: Target
    },
    {
      id: 6,
      title: 'Jal Jeevan Mission Strategy Formulation ',
      category: 'Water & Sanitation',
      location: 'Uttarakhand',
      client: 'Alliance Organization',
      details: 'Supported Alliance Organization in designing strategy for implementation of Jal Jeevan Mission Project in Uttarakhand',
      impact: 'Improved water access in rural communities',
      icon: Settings
    },
    {
      id: 7,
      title: 'Sustainable Livelihood Development',
      category: 'Livelihood',
      location: 'Sonbhadra, Uttar Pradesh',
      client: 'Lanco Foundation',
      details: 'Developed Sustainable Livelihood through skill development in Lanco Anpara Power Industrial area, Sonbhadra, Uttar Pradesh for Lanco Foundation – A CSR Initiative',
      impact: 'Enhanced livelihood opportunities for local communities',
      icon: Users
    },
    {
      id: 8,
      title: 'Health Program Strategy Development',
      category: 'Health',
      location: 'Bihar',
      client: 'Charity Science Health',
      details: 'Technical Assistance to Charity Science Health, a Canadian based Trust to strategize their program in the state of Bihar and supported in getting approval from state health ministry and field implementation',
      impact: 'Expanded health services in underserved areas',
      icon: Heart
    },
    {
      id: 9,
      title: 'Human Resource Complete Solutions',
      category: 'HR Solutions',
      location: 'Multiple Locations',
      client: 'NASSCOM Foundation, Frankfinn Aviations Services Pvt Ltd, Pronto International, Room to Read, Shri Sai Lions Netralayal, Unit Microsoft, Pavaani',
      details: 'Human Resource Solutions to various partners like Vansh Infertility Center, Damodar Solutions, Sri Sai Lions Netralaya, Pronto International and etc',
      impact: 'Improved organizational efficiency and performance',
      icon: Users
    },
    {
      id: 10,
      title: 'Strengthening Maternal Health Systems',
      category: 'Health',
      location: 'Multiple States',
      client: 'American India Foundation',
      details: 'Enabled LaQshya-based mentoring, infrastructure planning, feedback design, and quality orientation—advancing AIF’s maternal health impact across public facilities',
      impact: 'Enhanced Maternal health awareness in rural communities and women',
      icon: Building2
    },

    {
      id: 11,
      title: 'Financial & Statutory Compliance Support',
      category: 'Financial Services',
      location: 'Multiple States',
      client: 'NGO,Kisan Vikas Samiti, Global Insurfina IMF LLP ',
      details: 'Delivering end-to-end financial and regulatory compliance solutions for NGOs and MSMEs—ensuring transparency, legal adherence, and operational integrity.',
      impact: 'Increased financial inclusion in rural and urban areas',
      icon: Building2
    },
    {
      id: 13,
      title: 'JalAadhar -Rejuvenation of Water Bodies',
      category: 'Impact Assessment',
      location: 'Jaipur and Barmer',
      client: 'Tata Capital Housing Finance Ltd and ATE Chandra Foundation',
      details: 'Address water scarcity, improving groundwater recharge, and promoting sustainable water resource management through the revival of traditional water harvesting structures',
      impact: 'Increased water level of the ground',
      icon: Building2
    },
    {
      id: 14,
      title: 'Integrated Rural Development Project',
      category: 'Impact Assessment',
      location: 'Rayagada & Puri',
      client: 'Prayatn Sanstha supported by HDFC Parivartan',
      details: 'Development initiative with special focus on livelihood development, improving the quality of education, skill development and water and sanitation improvement.',
      impact: 'Enhanced livelihood option in rural areas',
      icon: Building2
    },
    {
      id: 15,
      title: 'Harit Dhara Rajesthan based Project',
      category: 'Impact Assessment',
      location: 'Rajasthan',
      client: 'Dhara Sansthan supported by Vedanta Cairn Oil and Gas',
      details: 'Aimed at address critical gaps in menstrual hygiene management (MHM) and supported as CSR Initiative of Vedanta Cairn Oil and Gas.',
      impact: 'Increased menstrual health awarness in rural areas',
      icon: Building2
    }
  ];

  const categories = ['All', 'Health', 'Education', 'Capacity Building', 'Research', 'Water & Sanitation', 'Livelihood', 'HR Solutions', 'Financial Services', 'Impact Assessment'];

  const filteredProjects = projectsData.filter(project => {
    const matchesCategory = selectedCategory === 'All' || project.category === selectedCategory;
    const matchesSearch = project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.details.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const stats = [
    { icon: Award, value: "200+", label: "Projects Completed" },
    { icon: Users, value: "100+", label: "Clients Served" },
    { icon: MapPin, value: "8+", label: "States Covered" },
    { icon: Star, value: "95%", label: "Success Rate" },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white pt-32 pb-20 overflow-hidden">
        {/* Animated Background Pattern */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-10 w-40 h-40 border border-primary-400 rounded-full animate-spin-slow"></div>
          <div className="absolute top-40 right-20 w-32 h-32 border border-accent-400 rounded-full animate-spin-slow-reverse"></div>
          <div className="absolute bottom-32 left-1/4 w-24 h-24 border border-primary-300 rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-1/3 w-20 h-20 border border-accent-300 rounded-full animate-pulse delay-1000"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-16 left-1/4 w-2 h-2 bg-primary-400 rounded-full animate-bounce"></div>
        <div className="absolute top-32 right-1/4 w-3 h-3 bg-accent-400 rounded-full animate-bounce delay-1000"></div>
        <div className="absolute bottom-40 left-1/3 w-1 h-1 bg-primary-500 rounded-full animate-bounce delay-2000"></div>

        <div className="container-custom relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-8"
            >
              <div className="space-y-6">
                <div className="inline-flex items-center px-4 py-2 bg-primary-500/20 text-primary-300 rounded-full text-sm font-semibold border border-primary-400/30">
                  <Award className="h-4 w-4 mr-2" />
                  Proven Track Record
                </div>
                <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-accent-400">Success Stories</span>
                </h1>
                <p className="text-xl text-gray-300 leading-relaxed">
                  Discover our portfolio of impactful projects that have transformed organizations and communities across India. Each project represents our commitment to excellence and social impact.
                </p>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">

                <motion.button
                  onClick={() => navigate('/contactus')}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="border-2 border-primary-400 text-primary-300 px-8 py-4 rounded-xl font-semibold hover:bg-primary-500 hover:text-white transition-all duration-300"
                >
                  Start Your Project
                </motion.button>
              </div>
            </motion.div>

            {/* Right Content - Stats Cards */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="grid grid-cols-2 gap-6"
            >
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 + index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="flex justify-center mb-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                      <stat.icon className="h-6 w-6 text-white" />
                    </div>
                  </div>
                  <div className="text-3xl font-bold text-white text-center mb-1">{stat.value}</div>
                  <div className="text-sm text-gray-300 text-center font-medium">{stat.label}</div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Filter and Search Section */}
      <section className="section-padding bg-gradient-to-br from-secondary-50 to-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-secondary-900 mb-6">
              Project <span className="text-gradient">Portfolio</span>
            </h2>
            <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
              Explore our diverse portfolio of successful projects across multiple sectors and regions.
            </p>
          </motion.div>

          {/* Filters */}
          <div className="flex flex-col gap-6 mb-12">
            {/* Search */}
            <div className="w-full max-w-4xl mx-auto">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-secondary-400" />
                <input
                  type="text"
                  placeholder="Search projects..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-4 border border-secondary-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all text-lg"
                />
              </div>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg font-medium transition-all ${selectedCategory === category
                      ? 'bg-primary-600 text-white shadow-medium'
                      : 'bg-white text-secondary-700 border border-secondary-200 hover:border-primary-300'
                    }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group"
              >
                <div className="bg-white rounded-2xl h-full overflow-hidden transition-all duration-500 group-hover:transform group-hover:-translate-y-2 group-hover:shadow-xl border border-gray-200 hover:border-primary-300">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-primary-600 to-accent-600 p-6 text-white">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                        <project.icon className="h-6 w-6 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold">{project.title}</h3>
                        <p className="text-white/80 text-sm">{project.category}</p>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <div className="space-y-4 mb-6">
                      <div className="flex items-center space-x-2 text-sm text-secondary-600">
                        <MapPin className="h-4 w-4" />
                        <span>{project.location}</span>
                      </div>
                      <div className="flex items-center space-x-2 text-sm text-secondary-600">
                        <Building2 className="h-4 w-4" />
                        <span>{project.client}</span>
                      </div>
                    </div>

                    <p className="text-secondary-600 leading-relaxed mb-4">
                      {project.details}
                    </p>

                    <div className="bg-gray-50 p-3 rounded-lg mb-6">
                      <p className="text-sm text-gray-700 font-medium">
                        <span className="font-semibold">Impact:</span> {project.impact}
                      </p>
                    </div>

                    {/* CTA */}
                    {/* <div className="flex items-center justify-between">
                      <button className="text-primary-600 font-semibold hover:text-primary-700 transition-colors flex items-center group">
                        View Details 
                        <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                      </button>
                      <div className="w-2 h-2 rounded-full bg-primary-600"></div>
                    </div> */}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-12"
            >
              <div className="text-secondary-400 mb-4">
                <Search className="h-16 w-16 mx-auto" />
              </div>
              <h3 className="text-xl font-semibold text-secondary-700 mb-2">No projects found</h3>
              <p className="text-secondary-600">Try adjusting your search criteria or category filter.</p>
            </motion.div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-primary-600 to-accent-600">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-white"
          >
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Let's discuss how we can help you achieve your project goals with our proven expertise and comprehensive solutions.
            </p>
            <motion.button
              onClick={() => navigate('/contactus')}
              className="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-4 px-8 rounded-lg transition-all duration-300 shadow-large group"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="flex items-center">
                Start Your Project
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </span>
            </motion.button>
          </motion.div>
        </div>
      </section>

      {/* Partners Section */}
      <Partners />
    </div>
  );
};

export default Projects;
